<template>
  <div class="content_all pay-service-row">
    <div class="listrow font12 font_weight500">
      <div class="listrow_left clb045">支付方式</div>
      <div class="listrow_right flex_right">
        <div
          v-for="type in payModeList"
          :key="type"
          class="option_item"
          @click="changePayType(type)"
        >
          <img
            :src="payType == type ? selectImg : unSelectImg"
            class="option_radio_icon"
          />
          <span class="option_label" :class="{ color_huang: payType == type }">
            {{ getPayTypeName(type) }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PayModeSelect",
  props: {
    payType: {
      type: [Number, String],
      default: null
    },
    payModeList: {
      type: Array,
      default() {
        return [];
      }
    },
    selectImg: {
      type: String,
      required: true
    },
    unSelectImg: {
      type: String,
      required: true
    }
  },
  methods: {
    changePayType(type) {
      this.$emit("change", type);
    },
    getPayTypeName(type) {
      return parseInt(type) === 1 ? "线上支付" : "线下支付";
    }
  }
};
</script>

<style lang="less" scoped>
.content_all {
  background-color: white;
  overflow: hidden;
  margin: 12px 0 0;
}

.listrow {
  padding: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.listrow_left {
  display: flex;
  align-items: center;
  color: rgba(0, 0, 0, 0.45);
}

.listrow_right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.flex_right {
  display: flex;
  justify-content: flex-end;
  flex: auto;
  align-items: center;
}

.option_item {
  display: flex;
  align-items: center;
  margin-left: 15px;
  cursor: pointer;

  .option_radio_icon {
    width: 16px;
    height: 16px;
    margin-right: 4px;
    flex-shrink: 0;
  }

  .option_label {
    font-size: 12px;
    font-weight: 500;
    color: #383838;

    &.color_huang {
      color: #bf9264;
    }
  }
}
</style>
